export interface IAction {
  readonly id: string
  readonly canAction: boolean
  readonly url: string
}